import React from "react";
import _ from "lodash";
import { Text, View } from "@react-pdf/renderer";
import { styles } from "../styles";
import { translate } from "../translate";
import {
  getCustomerPriceGroup,
  getCustomerForId,
  getPriceForColorAndSizeAndGroup,
} from "../../../selectors";
import { formatMoney } from "../money";
import { sortSizes } from "../../../utils/sizes";
import { hideTotals } from "../utils/calculateTotals";

const getPricesForProduct = (product, priceGroup, size) => {
  const mrspPrice =
    getPriceForColorAndSizeAndGroup({
      context: product.context,
      priceGroup,
      color: product.color,
      size,
      number: product.number,
      season: product.season,
      priceType: "m",
      withoutCaching: true,
    }) || {};
  const unitPrice =
    getPriceForColorAndSizeAndGroup({
      context: product.context,
      priceGroup,
      color: product.color,
      size,
      number: product.number,
      season: product.season,
      priceType: "u",
      withoutCaching: true,
    }) || {};
  return { unitPrice, mrspPrice };
};

const SpacerToPushNextElementToOtherLine = () => (
  <View
    style={{
      width: "100%",
      flexWrap: "nowrap",
    }}
  />
);

const MAX_PER_LINE = 6;

const Headers = ({ showTotals }) => (
  <View style={[styles.quantity, styles.quantityLegend]}>
    <Text style={[styles.black, styles.bold]}>{translate("headers.size")}</Text>
    <Text style={[styles.black, styles.bold]}>
      {translate("headers.amount")}
    </Text>
    {showTotals && (
      <>
        <Text style={[styles.black, styles.bold]}>
          {translate("headers.unit")}
        </Text>
        <Text style={[styles.black, styles.bold]}>
          {translate("headers.msrp")}
        </Text>
      </>
    )}
  </View>
);

export const ProductSizeQuantities = ({ order, product }) => {
  const sizes = sortSizes(_.keys(product.quantities));
  const filteredSizes = sizes.filter((size) => {
    const quantity = product.quantities[size];
    if (quantity === 0) {
      return false;
    }
    return true;
  });

  const showTotals = !hideTotals(order);

  return (
    <View style={styles.quantities} key={`product-${product.number}`}>
      {filteredSizes.map((size, i) => {
        const quantity = product.quantities[size];
        const customer = getCustomerForId(product.context, product.customerId);
        const priceGroup = getCustomerPriceGroup(product.context, customer);

        const { unitPrice, mrspPrice } = getPricesForProduct(
          product,
          priceGroup,
          size,
        );

        const isMaxPerLines = i % MAX_PER_LINE === 0;
        const isFirst = i === 1;

        const key = `${product.number}-${size}`;

        return (
          <React.Fragment key={key}>
            {isFirst ||
              (isMaxPerLines && (
                <>
                  {isMaxPerLines && (
                    <>
                      <SpacerToPushNextElementToOtherLine />
                    </>
                  )}
                  <Headers showTotals={showTotals} />
                </>
              ))}
            <View id={size} style={styles.quantity}>
              <Text>{size}</Text>
              <Text>{quantity}</Text>
              {showTotals && (
                <>
                  <Text>{formatMoney(unitPrice.value, "")}</Text>
                  <Text>{formatMoney(mrspPrice.value, "")}</Text>
                </>
              )}
            </View>
          </React.Fragment>
        );
      })}
    </View>
  );
};
